<template>
  <v-app-bar fixed app color="blue" :hide-on-scroll="pageIsCalculator">
    <v-container>
      <v-row>
        <v-toolbar-title @click="renderHomePageView">
          <v-img
            src="@/assets/images/LeanRevisions-hLogo.png"
            alt="lean revisions logo"
            width="150"
            class="has-cursor-pointer"
            contain
          />
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items id="desktop-nav-options" class="hidden-sm-and-down">
          <div>
            <v-btn
              color="white"
              fab
              small
              icon
              class="ml-2"
              v-if="userIsLoggedIn"
              @click="renderCalculatorView"
            >
              <v-icon>fas fa-calculator</v-icon>
            </v-btn>
            <v-btn
              color="white"
              fab
              small
              icon
              class="ml-2"
              v-if="userIsLoggedIn"
              @click="renderSummaryDashboardView"
            >
              <v-icon>fas fa-chart-bar</v-icon>
            </v-btn>
            <v-btn
              color="white"
              fab
              small
              icon
              class="ml-2"
              @click="$emit('show-contact-us')"
            >
              <v-icon>fas fa-question-circle</v-icon>
            </v-btn>
          </div>
        </v-toolbar-items>

        <v-toolbar-items
          v-if="!userIsLoggedIn"
          id="desktop-auth-options"
          class="hidden-sm-and-down"
        >
          <v-btn outlined :to="{ name: 'login' }" color="white" class="mr-2">
            Log In
          </v-btn>
          <v-btn :to="{ name: 'register' }" color="white">
            Sign Up
          </v-btn>
        </v-toolbar-items>

        <v-menu v-if="userIsLoggedIn" offset-y>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" class="hidden-sm-and-down" color="white">
              <v-icon>fas fa-caret-down</v-icon>
            </v-btn>
          </template>

          <v-list dense>
            <v-list-item-group>
              <v-list-item :to="{ name: 'edit-profile' }">
                <v-list-item-icon>
                  <v-icon small class="mt-1">fas fa-user</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  Edit Profile
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click.prevent="logout">
                <v-list-item-icon>
                  <v-icon small class="mt-1">fas fa-sign-out-alt</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  Logout
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-menu>
      </v-row>
    </v-container>

    <v-menu id="mobile-menu" right bottom>
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on" class="d-flex d-md-none">
          <v-icon color="blue">mdi-menu</v-icon>
        </v-btn>
      </template>

      <v-list>
        <div id="mobile-nav-options" v-if="userIsLoggedIn">
          <v-list-item
            v-if="showCalculatorButton"
            @click="renderCalculatorView"
          >
            <v-list-item-title>
              <v-icon small class="mr-1" color="green lighten-1"
                >fas fa-calculator</v-icon
              >
              Calculator
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="showDashboardButton"
            @click="renderSummaryDashboardView"
          >
            <v-list-item-title>
              <v-icon small class="mr-1" color="purple lighten-1"
                >fas fa-chart-bar</v-icon
              >
              Dashboard
            </v-list-item-title>
          </v-list-item>
        </div>
        <v-list-item @click="$emit('show-contact-us')">
          <v-list-item-title>
            <v-icon small class="mr-1" color="blue lighten-1"
              >fas fa-comments</v-icon
            >
            Contact Us
          </v-list-item-title>
        </v-list-item>

        <v-divider></v-divider>

        <div id="mobile-auth-options">
          <v-list-item @click.prevent="logout" v-if="userIsLoggedIn">
            <v-list-item-title>
              <v-icon small class="mr-1">fas fa-sign-out-alt</v-icon>
              Logout
            </v-list-item-title>
          </v-list-item>
          <span v-if="!userIsLoggedIn">
            <v-list-item :to="{ name: 'login' }">
              <v-list-item-title>
                <v-icon small class="mr-1">fas fa-user</v-icon>
                Log In
              </v-list-item-title>
            </v-list-item>
            <v-list-item :to="{ name: 'register' }">
              <v-list-item-title>
                <v-icon small class="mr-1">fas fa-sign-in-alt</v-icon>
                Sign Up
              </v-list-item-title>
            </v-list-item>
          </span>
        </div>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
export default {
  name: "the-navbar",
  props: {
    page: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    completed() {
      return this.$store.state.completed;
    },
    showHomeButton() {
      return this.page > 1;
    },
    showCalculatorButton() {
      return this.page !== 2;
    },
    showDashboardButton() {
      return this.page !== 3 && this.completed;
    },
    pageIsCalculator() {
      return this.$route.path === "/calculator";
    },
    userIsLoggedIn() {
      return this.$store.getters.userIsLoggedIn;
    },
  },
  methods: {
    renderHomePageView() {
      this.$router.push({
        name: "home",
        params: {
          thePage: 1,
        },
      });
    },
    renderCalculatorView() {
      this.$router.push({
        name: "calculator",
        params: {
          thePage: 2,
        },
      });
    },
    renderSummaryDashboardView() {
      this.$router.push({
        name: "summary-dashboard",
        params: {
          thePage: 3,
        },
      });
    },
    logout() {
      const user = {};
      this.$firebase
        .auth()
        .signOut()
        .then(() => {
          this.$store.dispatch("fetchUser", { user });
          this.$router.push({
            name: "home",
          });
        });
    },
  },
};
</script>
